var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-status-chip"},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":_vm.small ? '20' : '25',"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"color"},[_vm._v(_vm._s(_vm.statusText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }